import HotelCardPrice from './HotelCardPrice';

export default HotelCardPrice;
